//***Get master files into dropdownliat */
export const ExcelUploadGetTables = async (usercode, isExport) => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }

        };

        const response = await fetch(`${ApiURL}ExcelUpload/tables/${usercode}/${isExport}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.data.length > 0) {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: {} };
        }
        return { success: false, data: {} };
    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}

//*********************************************************************  */




//***Get excel file structure according to the selected master file */
export const ExcelUploadGetTableStructure = async (selectedExcelOption) => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ recordNo: selectedExcelOption })

        };

        const response = await fetch(`${ApiURL}ExcelUpload/structure`, requestOptions);
        const responseData = await response.json();

        if (response.status === 200) {
            if (responseData.success) {
                return { success: true, data: responseData.excel };
            } else {
                return { success: false, data: {} };
            }

        } else {
            console.error(`API request failed with status code: ${response.status}`);
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}
//************************************************************************** */



//***Upload excel file  */
export const handleUpload = async (file, selectedExcelOption, LogUserType) => {
    const formData = new FormData();
    formData.append('excelFile', file);
    formData.append('recordNo', selectedExcelOption);
    formData.append('logUser', LogUserType);

    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}ExcelUpload/upload`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        });

        if (response.ok) {
            const data = await response.json();

            if (data.success == true) {
                return { success: true, msg: data.msg };
            } else {
                return { success: false, msg: data.msg };
            }
        } else {
            return { success: false, msg: "Something went wrong!" };
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        return { success: false, msg: 'Error uploading file' };
        // Handle errors
    }
};


export const getLocation = async () => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}Locations/select`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (error) {
        console.error('Error fetching locations:', error);
        return { success: false, data: [] };
    }
};
